/** @description 입력한 번호가 유효한 휴대폰 번호인지 체크하는 함수 */
export const phoneNumberValidator = (phoneNumber: string): boolean => {
  const regex = /^010\d{8}$/;
  return regex.test(phoneNumber);
};

/** @description ID가 조건(영문 또는 영문+숫자 3자~15자 이내)에 맞는지 체크하는 함수 */
export const idValidator = (id: string): boolean => {
  const regex = /^(?=.*[A-Za-z])[A-Za-z0-9]{3,15}$/;
  return regex.test(id);
};

/** @description 회원가입 시 ID가 조건(영소문자 또는 영소문자+숫자 3자~15자 이내)에 맞는지 체크하는 함수 */
export const registerIdValidator = (id: string): boolean => {
  const regex = /^(?=.*[a-z])[a-z0-9]{3,15}$/;
  return regex.test(id);
};

// 연속 숫자: 정/역방향 + 순환 (동일 숫자 반복은 허용)
const SEQUENTIAL_NUMBER_REGEX = /(012|123|234|345|456|567|678|789|890|901|210|321|432|543|654|765|876|987|109|098)/;

/** @description 비밀번호에 3자리 이상 연속된 숫자가 포함되어 있는지 체크하는 함수 */
export const hasSequentialNumber = (pw: string): boolean => SEQUENTIAL_NUMBER_REGEX.test(pw);

/** @description 비밀번호가 조건(영문,숫자,특수문자가 포함된 8~20자, 연속 숫자 불가)에 맞는지 체크하는 함수 */
export const pwValidator = (pw: string): boolean => {
  const regex =
    /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+|<>?:{}\-=,./\\[\]])[A-Za-z\d~!@#$%^&*()_+|<>?:{}\-=,./\\[\]]{8,20}$/;
  return regex.test(pw) && !SEQUENTIAL_NUMBER_REGEX.test(pw);
};

/** @description 이름에 영문, 한글만 포함되었는지 체크하는 함수 */
export const nameValidator = (name: string): boolean => {
  const regex =
    /^(?:[가-힣ㄱ-ㅎㅏ-ㅣa-zA-Zᄀᆞᄂᆞᄃᆞᄅᆞᄆᆞᄇᆞᄉᆞᄋᆞᄌᆞᄎᆞᄏᆞᄐᆞᄑᆞᄒᆞ\u318D\u119E\u11A2\u2022\u2025\u00B7\uFE55\uFE52]{1,})$/;
  return regex.test(name);
};

/** @description 주민등록번호가 조건(6자리 숫자+하이픈+7자리 숫자)로 이루어져 있는지 확인하는 함수 */
export const identificationNumberValidator = (value: string): boolean => {
  const regex = /\d{6}-\d{7}$/;
  return regex.test(value);
};
